import {
  BriefcaseBusiness,
  EarthLock,
  Landmark,
  Newspaper,
  Package,
  ReceiptCent,
  WalletCards,
} from "lucide-react";
import MainContainer from "../../components/container/MainContainer";
import TransactionGridItem from "../../components/container/TransactionGridItem";
import TransactionGridContainer from "../../components/container/TransactionGridContainer";

const Report = () => {
  return (
    <MainContainer>
      <div>
        <h3 className="text-text-1/80">Financial Reports</h3>

        <TransactionGridContainer title="Reports">
          <TransactionGridItem
            component={ReceiptCent}
            title="Account Report"
            link="/reports/account-report"
          />
          <TransactionGridItem
            component={Package}
            title="Cash Flow Report"
            link="/reports/cash-flow-report"
          />
          <TransactionGridItem
            component={WalletCards}
            title="Donors Report"
            link="/reports/donors-report"
          />
          <TransactionGridItem
            component={WalletCards}
            title="Expenditure Variance"
            link="/reports/expenditure-variance-report"
          />
          <TransactionGridItem
            component={WalletCards}
            title="Income Variance"
            link="/reports/income-variance-report"
          />
          <TransactionGridItem
            component={WalletCards}
            title="Monthly Financial"
            link="/reports/monthly-financial-report"
          />
          <TransactionGridItem
            component={WalletCards}
            title="Financial Statement"
            link="/reports/financial-statement"
          />
        </TransactionGridContainer>
        {/* Invoices and Pledges */}
        <TransactionGridContainer title="Pledges | Vendors">
          <TransactionGridItem
            title="Pledges"
            component={Package}
            link="/pledges"
          />
          <TransactionGridItem
            title="Vendors"
            component={BriefcaseBusiness}
            link="/vendors"
          />
        </TransactionGridContainer>
      </div>
    </MainContainer>
  );
};

export default Report;
